var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMainLeft = function SvgMainLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.99 4h-12L11.44 24l11.55 20h12L23.44 24 34.99 4z"
  })));
};
export { SvgMainLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iZjhhZTY1ZDItMzllOS00NmZiLTk1MGUtMjRkZjJmOTEwYWFiIiBkYXRhLW5hbWU9IiZsdDtMYXllciZndDsiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+bWFpbl9sZWZ0PC90aXRsZT48cG9seWdvbiBwb2ludHM9IjM0Ljk5IDQgMzAuOTkgNCAzMC45OSA0IDI2Ljk5IDQgMjYuOTkgNCAyMi45OSA0IDExLjQ0IDI0IDIyLjk5IDQ0IDI2Ljk5IDQ0IDI2Ljk5IDQ0IDMwLjk5IDQ0IDMwLjk5IDQ0IDM0Ljk5IDQ0IDIzLjQ0IDI0IDM0Ljk5IDQiLz48L3N2Zz4K";